    <div class="woop-background">
        <div class="woop-background__inner">
            <div class="woop-background__word">
                <div class="woop-background__letter woop-background__letter--w">W</div>
                <div class="woop-background__letter woop-background__letter--o1">O</div>
                <div class="woop-background__letter woop-background__letter--o2">O</div>
                <div class="woop-background__letter woop-background__letter--p">P</div>
                <div class="woop-background__letter woop-background__letter--ex">!</div>
            </div>
        </div>
    </div>